import DesktopTooltip from './mapbox-click-tooltip/index';
import MobileTooltip from './mapbox-mobile-click-tooltip/index';
import RowTooltip from './mapbox-row-hover-tooltip/index';
import setupTooltipLayout from './mapbox-tooltip-layout/index';

const RowHoverTooltip = setupTooltipLayout(RowTooltip);
const DesktopClickTooltip = setupTooltipLayout(DesktopTooltip);
const MobileClickTooltip = setupTooltipLayout(MobileTooltip);

export {RowHoverTooltip, DesktopClickTooltip, MobileClickTooltip};
